// src/Components/services/serviceContent.ts



import CloudItServices from "../../assets/11.png";
import ItRecruitmentEngineering from "../../assets/22.png";
import AsicFpgaSolutions from "../../assets/33.png";
import FiveGTelecomSolutions from "../../assets/44.png";

export type LayoutType =
  | "consulting-service"
  | "staffing-service"
  | "software-service"
  | "project-service";

export interface ServiceCapability {
  title: string;
  summary: string;
  details: string;
}

export interface ServiceContentItem {
  /* ===== Hero Banner ===== */
  heroImage: string;          // background image
  title: string;          // big heading
  subtitle: string;       // supporting line

  /* ===== Intro ===== */
  description: string;          // replaces left/right split

  /* ===== Core Content ===== */
  capabilities: ServiceCapability[];

  /* ===== Highlights ===== */
  highlights: string[];

  /* ===== Layout Control ===== */
  // layout: LayoutType;
}


export const SERVICE_CONTENT: Record<string, ServiceContentItem> = {
  "consulting-service": {
    "title": "Consulting Technology Services",
    "subtitle": "From silicon to software, we deliver integrated solutions that transform how enterprises design, build, and operate.",
    "heroImage": CloudItServices,
    "description": "At Nordic Integration, we bridge the gap between business goals and technical execution—helping clients transform innovative ideas into successful products. Our consulting services provide end-to-end support across the semiconductor development lifecycle, ensuring precision, speed, and measurable results. We focus on assembling the right talent at the right time, building skilled teams that deliver excellence from concept to completion.",
    "capabilities": [
      {
        "title": "Semiconductor Engineering",
        "summary": "ASIC / SoC design and verification expertise",
        "details": "Expertise across ASIC and SoC design and verification, physical design, static timing analysis (STA), synthesis, design for test (DFT), FPGA development, and post-silicon validation."
      },
      {
        "title": "Concept-to-Silicon Design",
        "summary": "End-to-end ASIC and SoC development",
        "details": "Comprehensive design services covering architecture definition, RTL design, functional verification, physical implementation, and silicon readiness."
      },
      {
        "title": "Reconfigurable Systems",
        "summary": "FPGA-based embedded system development",
        "details": "FPGA-based embedded system development from initial concept through system design, prototyping, integration, and evaluation."
      },
      {
        "title": "Embedded & Software Solutions",
        "summary": "Embedded, application, and cloud software",
        "details": "Software development for reconfigurable embedded systems, Linux and Windows applications, and cloud-based software solutions."
      },
      {
        "title": "Training & Skill Development",
        "summary": "Customized technical training programs",
        "details": "Customized training programs covering design methodologies, UVM-based verification, HDL and HVL languages, and vendor-specific tools."
      },
      {
        "title": "Testing & Quality Assurance",
        "summary": "Hardware and software testing services",
        "details": "Manual and automated testing services for both hardware and software systems to ensure quality, reliability, and compliance."
      }
    ],
    "highlights": [
      "End-to-end semiconductor consulting",
      "Deep technical expertise",
      "Flexible team engagement",
      "Focus on quality and measurable outcomes"
    ]
  },


  "staffing-service": {
    "title": "Engineering Staffing Services",
    "subtitle": "The right talent, at the right time, for your most critical projects.",
    "heroImage": ItRecruitmentEngineering,
    "description": "Nordic Integration specializes in recruiting Analog and Digital Microelectronics engineers across the full spectrum of skills—from System Architects to Post-Silicon Validation experts. In today’s fast-paced market, having the right talent at the right time can make all the difference. We deliver flexible, cost-effective staffing solutions tailored to your project needs.",
    "capabilities": [
      {
        "title": "Analog & Digital Engineering Talent",
        "summary": "Specialized microelectronics expertise",
        "details": "Recruitment of experienced Analog and Digital Microelectronics engineers covering architecture, design, verification, and validation roles."
      },
      {
        "title": "Flexible Staffing Models",
        "summary": "Tailored engagement options",
        "details": "Flexible staffing solutions customized across skills, experience levels, technologies, domains, locations, and project durations."
      },
      {
        "title": "Global Talent Network",
        "summary": "Access to vetted consultants worldwide",
        "details": "A global network of pre-vetted technical consultants enabling faster onboarding and accelerated project delivery."
      }
    ],
    "highlights": [
      "Vetted technical consultants",
      "Global talent reach",
      "Flexible engagement models",
      "Cost-effective staffing solutions"
    ]
  },

  "software-service": {
    "title": "SAP & Software Services",
    "subtitle": "Driving digital transformation with next-generation SAP solutions.",
    "heroImage": AsicFpgaSolutions,
    "description": "We take pride in our team of highly skilled SAP consultants specializing in SAP S/4HANA—the next-generation intelligent ERP system. With deep expertise across multiple SAP modules, our consultants deliver successful SAP implementations, upgrades, and ongoing support services aligned with business needs.",
    "capabilities": [
      {
        "title": "SAP S/4HANA Expertise",
        "summary": "Next-generation ERP solutions",
        "details": "Implementation, migration, and optimization of SAP S/4HANA solutions tailored to enterprise requirements."
      },
      {
        "title": "SAP Implementations & Upgrades",
        "summary": "End-to-end SAP delivery",
        "details": "Full lifecycle SAP services including system implementation, version upgrades, integration, and stabilization."
      },
      {
        "title": "Ongoing Support Services",
        "summary": "Reliable post-go-live support",
        "details": "Continuous SAP application support services ensuring system stability, performance, and business continuity."
      }
    ],
    "highlights": [
      "SAP S/4HANA specialists",
      "Digital transformation expertise",
      "Proven delivery experience",
      "Reliable long-term support"
    ]
  },

  "project-service": {
    "title": "Project Outsourcing Services",
    "subtitle": "Scalable engineering delivery without the overhead.",
    "heroImage":FiveGTelecomSolutions,
    "description": "Nordic Integration partners with clients for project-specific outsourcing engagements, working closely to define clear deliverables and execution plans. Our engineering teams operate from state-of-the-art development centers in Sweden and India, providing the right balance of cost efficiency and access to highly skilled technical talent.",
    "capabilities": [
      {
        "title": "Dedicated Engineering Teams",
        "summary": "Project-focused delivery teams",
        "details": "Dedicated project teams aligned to defined scopes, milestones, and quality benchmarks."
      },
      {
        "title": "Global Delivery Centers",
        "summary": "Sweden and India operations",
        "details": "Engineering delivery from modern development centers in Sweden and India, ensuring efficiency and scalability."
      },
      {
        "title": "Quality-Driven Execution",
        "summary": "Reliable and predictable outcomes",
        "details": "Strong focus on engineering quality, process discipline, and predictable project execution."
      }
    ],
    "highlights": [
      "Development centers in Sweden & India",
      "Cost-effective delivery model",
      "Access to top-tier technical talent",
      "Clear deliverables and accountability"
    ]
  }
}
;
